"use client";

import { Box } from "@mui/material";
import Image from "next/image";

/** The official App Store and Google Play badges (the footer's files), each linking to an
 * app's listing. The labels name the app, since the badge images only name the store. */
export function StoreBadges({
  appStore,
  googlePlay,
  height = 48,
}: {
  appStore: { href: string; label: string };
  googlePlay: { href: string; label: string };
  height?: number;
}) {
  const width = height * 3;
  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5, alignItems: "center" }}>
      <Box component="a" href={appStore.href} target="_blank" rel="noopener noreferrer" sx={{ display: "block", lineHeight: 0 }}>
        <Image src="/images/apple-app-store-badge_1.svg" alt={appStore.label} width={width} height={height} style={{ height, width: "auto" }} />
      </Box>
      <Box component="a" href={googlePlay.href} target="_blank" rel="noopener noreferrer" sx={{ display: "block", lineHeight: 0 }}>
        <Image src="/images/google_play.png" alt={googlePlay.label} width={width} height={height} style={{ height, width: "auto" }} />
      </Box>
    </Box>
  );
}
